import React from 'react';
import { useDispatch, useSelector } from 'react-redux'

import Aux from '../../hoc/Aux';
import { useForm,Controller } from 'react-hook-form'
import * as actions from '../../store/actions/index';
import Select from 'react-select'
import Navigation from './Navigation';
import { useTranslation } from 'react-i18next';
import useCustomHtmlTranslation from '../../hooks/useCustomHtmlTranslation';
import useCustomTranslation from '../../hooks/useCustomTranslation';


const settings = (props) => {

  const dispatch = useDispatch();
  const { handleSubmit, control, getValues } = useForm();
  const { t } = useTranslation();
  const ht = useCustomHtmlTranslation();
  const ct = useCustomTranslation();

  const onSubmit = data => {
    data = {...data, locale: Object(data.locale).code}
    dispatch( actions.saveSettings(data) );
  } ;

  const myProfile = useSelector(state => {
    return () => actions.getProfile(state)
  });

  let profile = myProfile() || {};

  const intialValues = {
    locale: profile["locale"],
  };


  const countryOptions = [
    { code: "DE", label: t('navigation.change_language.german') },
    { code: "EN", label: t('navigation.change_language.english') },
  ];

  return (
    <Aux>
    	<div className="main-container">
    		<div className="container">
    			<div className="row justify-content-center mt-5">
    				<div className="col-lg-10 col-xl-9">
    					<div className="page-header">
    						<h1 className="pb-2">{ ct('settings_account.title') }</h1>
                <span className="lead">
                  { ht('account.settings_description') }
                </span>
    					</div>
    				</div>
    			</div>
    			<div className="row justify-content-center mt-3">
    				<div className="col-lg-3 mb-3">
    					<Navigation activeItem="settings" />
    				</div>
    				<div className="col-lg-7 col-xl-6">
    					<div className="card">
    						<div className="card-body">
    							<div className="tab-content">
    								<div className="tab-pane fade show active" role="tabpanel" id="userdata">
                      <h4>{ ct('settings_account.subtitle') }</h4>
    									<form onSubmit={handleSubmit(onSubmit)}>
    										<div className="form-group row align-items-center">
    											<label className="col-3">{ ct('settings_account.form.user_locale') }</label>
    											<div className="col">
                            <Controller
                                as={Select}
                                defaultValue={countryOptions.find(o => o.code === intialValues.locale)}
                                options={countryOptions}
                                getOptionLabel={option => option.label}
                                getOptionValue={option => option.code}
                                value={countryOptions.find(o => o.code === getValues("locale"))}
                                onChange={([option]) => option.code}
                                name="locale"
                                control={control}
                              />
    											</div>
    										</div>
    										<div className="row justify-content-end">
    											<button type="submit" className="btn btn-primary btn-project">{ ct('settings_account.form.button.submit') }</button>
    										</div>
    									</form>
    								</div>
    							</div>
    						</div>
    					</div>
    				</div>
    			</div>
    		</div>
    	</div>
    </Aux>
  );


};

export default settings;



// WEBPACK FOOTER //
// ./src/components/User/Settings.js